import React from 'react';

const SocialProof: React.FC = () => {
  return (
    <section className="social-proof" aria-hidden="true" style={{ display: 'none' }}>
    </section>
  );
};

export default SocialProof; 